import { useState, useRef, useEffect } from "react";
import { MoreVertical } from "lucide-react";

export default function KebabMenu({ items }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function onClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    if (open) document.addEventListener("mousedown", onClickOutside);
    return () => document.removeEventListener("mousedown", onClickOutside);
  }, [open]);

  return (
    <div ref={ref} className="relative">
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(v => !v); }}
        className="p-1 rounded hover:bg-gray-100"
        aria-label="More actions"
      >
        <MoreVertical className="w-4 h-4" />
      </button>
      {open && (
        <div className="absolute right-0 top-8 z-10 bg-white border rounded shadow-lg min-w-[140px]">
          {items.map((it, i) => (
            <button
              key={i}
              onClick={(e) => { e.stopPropagation(); setOpen(false); it.onClick(); }}
              className={`w-full text-left px-3 py-2 text-sm hover:bg-gray-50 ${it.danger ? "text-red-700" : "text-gray-800"}`}
            >
              {it.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
